/**
 * Recreated brand mark for Beauty & Balance by Bella —
 * inspired by the triplebtherapy.com logo: gold script on navy with leafy laurel.
 *
 * Uses inline SVG so it scales crisply and adapts to color via `currentColor`.
 * Pass `tone="navy"` for navy script on cream surfaces, `tone="gold"` for gold on navy.
 */
export default function Logo({ tone = "gold", size = "md", showFrame = true, showSubtitle = true, className = "" }) {
  const stroke = tone === "navy" ? "#0F1F4E" : "#EAD584";
  const text = tone === "navy" ? "#0F1F4E" : "#EAD584";

  const heightClass =
    size === "xs" ? "h-8" :
    size === "sm" ? "h-10" :
    size === "md" ? "h-12" :
    size === "lg" ? "h-20 md:h-28" :
    size === "xl" ? "h-28 md:h-44" : "h-12";

  return (
    <svg
      viewBox="0 0 600 240"
      xmlns="http://www.w3.org/2000/svg"
      className={`${heightClass} w-auto ${className}`}
      role="img"
      aria-label="Beauty & Balance by Bella"
    >
      {showFrame && (
        <rect
          x="20"
          y="30"
          width="560"
          height="180"
          rx="3"
          fill="none"
          stroke={stroke}
          strokeWidth="1.5"
        />
      )}

      {/* Top-right laurel */}
      {showFrame && (
        <g stroke={stroke} strokeWidth="1.4" fill="none" strokeLinecap="round">
          <path d="M460 40 C 480 22, 510 18, 540 26" />
          {/* leaves */}
          <path d="M468 36 q 6 -10 14 -8 q -2 8 -8 12 z" fill={stroke} fillOpacity="0.0" />
          <path d="M478 30 q 7 -12 16 -9 q -2 8 -9 13 z" />
          <path d="M495 24 q 8 -10 18 -8 q -2 9 -10 12 z" />
          <path d="M515 22 q 8 -8 20 -6 q -3 9 -12 11 z" />
        </g>
      )}

      {/* Bottom-left laurel */}
      {showFrame && (
        <g stroke={stroke} strokeWidth="1.4" fill="none" strokeLinecap="round">
          <path d="M60 200 C 80 218, 110 222, 140 214" />
          <path d="M68 204 q 6 10 14 8 q -2 -8 -8 -12 z" />
          <path d="M82 210 q 7 12 16 9 q -2 -8 -9 -13 z" />
          <path d="M100 216 q 8 10 18 8 q -2 -9 -10 -12 z" />
          <path d="M120 218 q 8 8 20 6 q -3 -9 -12 -11 z" />
        </g>
      )}

      {/* Script main */}
      <text
        x="300"
        y="120"
        textAnchor="middle"
        fill={text}
        style={{ fontFamily: "'Pinyon Script', cursive", fontSize: 86 }}
      >
        Beauty &amp; Balance
      </text>

      {showSubtitle && (
        <>
          <line x1="170" y1="172" x2="240" y2="172" stroke={stroke} strokeWidth="1" />
          <line x1="360" y1="172" x2="430" y2="172" stroke={stroke} strokeWidth="1" />
          <text
            x="300"
            y="178"
            textAnchor="middle"
            fill={text}
            style={{ fontFamily: "'Manrope', sans-serif", fontSize: 18, letterSpacing: "10px", fontWeight: 500 }}
          >
            BY BELLA
          </text>
        </>
      )}
    </svg>
  );
}
